import axios from 'axios'
import { isFunction as _isFunction } from 'lodash'
import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const GetCallMeBackHistory = async (
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    onStart()

    try {
        const response = await axios.get(API_URLS.getHistory, {
            params: {
                msisdn: msisdn,
                type: 'sms',
            },
            headers: customHeaders,
        })

        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        } else {
            throw _error
        }
    }
}

const SendCallMeBack = async (
    receiver,
    msisdn,
    customHeaders = {},
    utilities = {},
) => {
    const _utilities = retrieveUtilities(utilities)

    const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

    const data = {
        'category': [
            {
                'listHierarchyId': '1',
                'value': 'sms',
            },
        ],
        'createdBy': {
            'schemeAgencyName': 'Vodafone',
            'value': '',
        },
        'desc': 'Call me back',
        'details': {
            'deliveryInd': {
                'indicator': false,
            },
            'prority': 'High',
            'readInd': {
                'indicator': false,
            },
            'receivedDateTime': {
                'value': '',
            },
            'sentDateTime': {
                'value': '',
            },
            'subject': 'Call Me Back',
        },
        'id': [
            {
                'schemeAgencyName': 'Vodafone',
                'schemeName': 'Communication ID',
                'value': '',
            },
        ],
        'name': 'Call me back',
        'parts': {
            'body': {
                'content': {
                    'category': [
                        {
                            'listHierarchyId': '1',
                            'value': 'sms',
                        },
                    ],
                    'desc': 'Call me Back',
                    'id': [
                        {
                            'schemeAgencyName': 'Vodafone',
                            'schemeName': 'Communication ID',
                            'value': '',
                        },
                    ],
                    'name': 'Call me Back',
                    'status': '',
                    'type': 'sms',
                },
                'shortText': `The number ${msisdn} is requesting you to call him back`,
                'text': `The number ${msisdn} is requesting you to call him back`,
            },
            'businessObject': {},
            'header': {
                'text': '',
            },
            'signature': {
                'text': '',
            },
            'specification': {},
            'trailer': {
                'text': '',
            },
        },
        'roles': {
            'receiver': {
                'category': [
                    {
                        'listHierarchyId': '1',
                        'value': 'customer',
                    },
                ],
                'desc': '',
                'email': {
                    'domainName': '',
                    'emailVerified': true,
                    'fullAddress': '',
                    'userName': '',
                },
                'id': [
                    {
                        'schemeAgencyName': 'Vodafone',
                        'schemeName': 'Communication ID',
                        'value': receiver,
                    },
                ],
                'name': '',
                'status': 'active',
                'type': 'customer',
            },
            'sender': {
                'category': [
                    {
                        'listHierarchyId': '1',
                        'value': 'customer',
                    },
                ],
                'desc': '',
                'email': {
                    'domainName': '',
                    'emailVerified': true,
                    'fullAddress': '',
                    'userName': '',
                },
                'id': [
                    {
                        'schemeAgencyName': 'Vodafone',
                        'schemeName': 'Communication ID',
                        'value': msisdn,
                    },
                ],
                'name': '',
                'status': 'active',
                'type': 'customer',
            },
        },
        'status': '',
        'type': 'sms',
        'validityPeriod': {
            'fromDate': {
                'date': '',
            },
            'toDate': {
                'date': '',
            },
        },
    }

    onStart()

    try {
        const response = await axios.post(API_URLS.getHistory, data, {
            headers: {
                ...customHeaders,
            },
            data: null,
        })

        const _response = responseMapper(response)
        onSuccess(_response)
        return _response
    } catch (error) {
        const _error = errorMapper(error)
        if (_isFunction(onError)) {
            onError(_error)
        }
        throw _error
    }
}

export { GetCallMeBackHistory, SendCallMeBack }
